import React from "react";
import {
  Card,
  Container,
  Grid,
  IconButton,
  Button,
  Typography,
  Slide,
  Link,
  useTheme,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Iconify from "components/iconify";
import { useLocalStorage } from "../../hooks/use-local-storage";
import { Link as RouterLink } from "react-router-dom";
import MKButton from "components/MKButton";
import { useSettingsContext } from "components/settings";

export default function CookiesBanner() {
  const theme = useTheme();
  const [settings, setSettings] = useLocalStorage("settings", {
    cookiesStatus: "",
    preferences: {
      analytics: false,
    },
  });

  const [visible, setVisible] = React.useState(settings.cookiesStatus === "");
  const [customizing, setCustomizing] = React.useState(false);
  const [preferences, setPreferences] = React.useState(settings.preferences);

  const onAcceptAll = () => {
    setSettings({
      cookiesStatus: "accepted",
      preferences: {
        analytics: true,
      },
    });
    setVisible(false);
    if (typeof window.enableAnalytics === "function") {
      window.enableAnalytics();
    }
  };
  const onRejectAll = () => {
    setSettings({
      cookiesStatus: "rejected",
      preferences: {
        analytics: false,
      },
    });
    setVisible(false);

    // Prevent GA from initializing or tracking
    if (typeof window !== "undefined") {
      window["ga-disable-G-FLNPLQLSKV"] = true;
    }
  };

  const onSavePreferences = () => {
    setSettings({
      cookiesStatus: "custom",
      preferences,
    });
    setVisible(false);

    if (preferences.analytics && typeof window.enableAnalytics === "function") {
      window.enableAnalytics();
    }
  };


  const onClose = () => {
    setVisible(false);
  };

  return (
    <Slide direction="up" in={visible} mountOnEnter unmountOnExit>
      <Container
        sx={{
          position: "fixed",
          bottom: 24,
          left: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <Card
          sx={{
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[6],
            border: `2px solid ${theme.palette.primary.main}`,
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: 2 }}
          >
            <Grid item xs={12} md={9}>
              <Grid container alignItems="flex-start" spacing={1}>
                <Grid item>
                  <InfoIcon color="primary" />
                </Grid>
                <Grid item xs>
                  <Typography variant="subtitle1" fontWeight="bold">
                    We use cookies 🍪
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    We use cookies to improve your experience and analyze usage. You can manage your
                    preferences or accept all.{" "}
                    <Link component={RouterLink} to="/privacy-policy" underline="hover" color="primary">
                      Learn more
                    </Link>
                  </Typography>

                  {customizing && (
                    <FormGroup sx={{ mt: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={preferences.analytics}
                            onChange={(e) =>
                              setPreferences((prev) => ({
                                ...prev,
                                analytics: e.target.checked,
                              }))
                            }
                          />
                        }
                        label="Allow analytics cookies"
                      />
                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            checked={preferences.marketing}
                            onChange={(e) =>
                              setPreferences((prev) => ({
                                ...prev,
                                marketing: e.target.checked,
                              }))
                            }
                          />
                        }
                        label="Allow marketing cookies"
                      /> */}
                    </FormGroup>
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={3}>
              <Grid container spacing={1} justifyContent="flex-end">
                {customizing ? (
                  <>
                    <Grid item>
                      <MKButton
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={onRejectAll}
                      >
                        Reject All
                      </MKButton>
                    </Grid>
                    <Grid item>
                      <MKButton
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={onSavePreferences}
                      >
                        Save
                      </MKButton>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item>
                      <MKButton
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => setCustomizing(true)}
                      >
                        Customize
                      </MKButton>
                    </Grid>
                    <Grid item>
                      <MKButton
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={onAcceptAll}
                      >
                        Accept All
                      </MKButton>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>

          <IconButton
            size="small"
            onClick={onClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <Iconify icon="eva:close-fill" width={20} />
          </IconButton>
        </Card>
      </Container>
    </Slide>
  );
}
